import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import { Form, Input, Button } from "antd";
import { Row, Alert } from "antd";
import { useTranslation } from "react-i18next";
import { UserOutlined } from "@ant-design/icons";
import { authActions } from "_actions";
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { useRef } from "react";
import NavbarNoLogin from "../../components/Header/Navbars/NavbarNoLogin";
import prefooter from "../../assets/img/prefooter.svg";
import { xcService } from "../../_services/xcService";
import { noCaptcha } from "_config";

function RecoverPasswordAsk(props) {

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const captchaRef = useRef(null)
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  var forgot = useSelector((state) => state.authReducer.forgot);
  var forgotError = useSelector((state) => state.authReducer.forgotError);

  useEffect(() => {
    //message.success(t("login.passwordSent"));
  }, [])
  useEffect(() => {
    setLoading(false);

    if (forgot) {
      setError(false);
      setSuccess(true);

    }
    if (forgotError) {
      setSuccess(false);
      setError(true);
      setErrorMsg(t(forgotError.code));
    }
  }, [forgot, forgotError]);

  const onFinish = (values) => {
    if (noCaptcha) {
      setLoading(true);
      setLoading(false);
      dispatch(authActions.forgotPassword(values.email));
      return;
    }

    const token = captchaRef.current.getValue();
    setLoading(true);

    xcService.post("/v1/captcha", { token }).then(res => {
      captchaRef.current.reset();
      if (res.data.success) {
        setLoading(false);
        dispatch(authActions.forgotPassword(values.email));

      } else {
        setLoading(false);
        setError(true);
        setErrorMsg("captcha");
      }

    })
      .catch((error) => {
        captchaRef.current.reset();
      })

  };

  return (
    <>
      <NavbarNoLogin className="menuNavLogin" />
      <div className="containerRowLogin">

        <div className="colRegister leftLogin">
          <h1>{t("welcomea")}</h1>
        </div>
        <div className="colRegister rightLogin">
          <div className={"formLogin"}>
            <div>
              <h3>{t("login.recuperarc")}</h3>
              <div className="customTextMedium is-required">{t("obligatorio")}</div>
              <div className="centerMobile">
                <Form
                  name="normal_login"
                  className="authForm allHeightMobile"
                  layout="vertical"
                  labelCol={{ span: 22 }}
                  wrapperCol={{ span: 22 }}
                  initialValues={{
                    remember: true,
                  }}
                  onFinish={onFinish}
                >


                  <div style={{ marginTop: 16 }}></div>

                  <Form.Item
                    label={t("login.email")}
                    name="email"
                    rules={[
                      {
                        type: "email",
                        message: t("login.emailIncorrect"),
                      },
                      {
                        required: true,
                        message: t("login.emailMandatory"),
                      },
                    ]}
                  >
                    <Input
                      prefix={<UserOutlined className="site-form-item-icon colorBlue" />}
                      placeholder={t("login.emailp")}
                    />
                  </Form.Item>


                  <Row>
                    <Link style={{ marginTop: 0, marginBottom: 24 }} className="linkForgot" to="/auth/login">{t("menu.inicia")}</Link>
                  </Row>


                  { !noCaptcha &&
                  <ReCAPTCHA ref={captchaRef}
                    sitekey={process.env.REACT_APP_SITE_KEY}
                  />
                  }

                  <Form.Item>
                    <Button
                      loading={loading}
                      htmlType="submit"
                      className="primaryButton buttonSizeXL"
                      type="primary"
                    >
                      {t("login.recover")}
                    </Button>
                    {success &&
                      <Alert message={t("login.passwordSent")} type="success" />
                    }
                    {error && <Alert message={errorMsg} type="error" />}
                  </Form.Item>
                </Form>
                <div className={"registerLogin"}>
                  <p style={{ marginBottom: 8 }}>{t("login.primera")}</p>
                  <p className={"customTextMedium"}>{t("login.crea")}</p>
                  <div>
                    <Button
                      href={"/auth/register"}
                      className="btnPrimaryWhite"
                      style={{ width: 150 }}
                    >
                      {t("home.student")}
                    </Button>
                    <Button
                      href={"/tutorAuth/register"}
                      className="btnPrimaryWhite"
                    >
                      {t("home.tutor")}
                    </Button>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div className="prefooter">
        <img className="prefooter-img" src={prefooter} alt={""} />
      </div>
    </>
  );
}
export default withTranslation()(RecoverPasswordAsk);
